<template>
  <de-layout-content>
    <!-- 头部 -->
    <div class="header">
      <div>
        <div class="alnCt">
          <span class="name mr20">{{ info.name }}</span>
          <div class="typeTag">{{ userTypeObj[info.type] }}</div>
        </div>
      </div>
      <div class="" style="text-align: right">
        <div class="top">
          <span style="color: #19be6b" v-if="info.status == 1">● 正常</span>
          <span style="color: #ff4d4f" v-else>● 禁用</span>
        </div>
        <div class="mt20" style="display: flex">
          <div class="mr20">
            <a-button type="primary" @click="linkMemberAnalyse" v-if="type == 2">
              分析报告
            </a-button>
          </div>
          <div class="mr20">
            <a-button type="primary" @click="linkMemberRecord" v-if="type == 2">
              数据档案
            </a-button>
          </div>
          <div class="mr20">
            <a-button type="primary" icon="setting" @click="changeGroup(1)">
              分配组别
            </a-button>
          </div>
          <div>
            <a-button type="primary" icon="setting" @click="changeStatus(1)">
              设置状态
            </a-button>
          </div>
        </div>
      </div>
    </div>

    <el-tabs v-model="tabName" @tab-click="tabClick" style="margin-top: 15px">
      <el-tab-pane label="个人资料" name="info">
        <!-- 成员详情 -->
        <el-card class="cyInfo">
          <!-- 运动员 -->
          <InfoAthletes v-if="type == 2"></InfoAthletes>
          <!-- 教练员 -->
          <InfoCoach v-if="type == 3"></InfoCoach>
          <!-- 管理人员-医疗人员 -->
          <InfoAdmin v-if="type == 1 || type == 4 || type == 5"></InfoAdmin>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="行踪记录" name="record">
        <div class="flex wz-color-white" style="margin-top: 15px；justify-content: center">
          <!-- 左侧日历部分 -->
          <div class="flxL">
            <DateManage title="日程管理" :time="time" @update="callBack"></DateManage>
          </div>
          <!-- 右侧部分 -->
          <div class="flxR flex-1 overflow-h wz-color-white" style="max-width: 1200px">
            <Content :passtype="type"></Content>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 弹框修改用户组别 -->
    <el-dialog :title="setGroupData.name + '- 修改组别'" :visible.sync="showChangeGroup" width="600px" append-to-body>
      <!-- <div class="wz-flex-row wz-align-center wz-mr-4 wz-mb-2">
        <div class="wz-text-right wz-mr-2" style="width: 110px">选择组别：</div>
        <SelectGroup
          :tId="setGroupData.tId"
          :gId="setGroupData.gId"
          @change="setGroupChange"
        ></SelectGroup>
      </div> -->
      <el-form :model="setGroupData" label-width="100px" class="demo-ruleForm">
        <el-form-item label="修改组别" class="isRequired">
          <SelectGroup :tId="setGroupData.tId" :gId="setGroupData.gId" @change="setGroupChange"></SelectGroup>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangeGroup = false">取 消</el-button>
        <el-button type="primary" @click="doChangeGroup">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹框修改用户组别 -->
    <el-dialog title="设置状态" :visible.sync="showChangeStatus" width="600px" append-to-body>
      <a-form :model="setStatusData">
        <a-form-item label="选择状态">
          <a-radio-group v-model="setStatusData.status" :options="statusOptions">
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="setStatusData.statusRemark" placeholder="输入备注" show-count :rows="4" :maxlength="200" />
        </a-form-item>
      </a-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangeStatus = false">取 消</el-button>
        <el-button type="primary" @click="doChangeStatus">确 定</el-button>
      </div>
    </el-dialog>
  </de-layout-content>
</template>
<script>
import moment from "moment";
import axios from "axios";
import * as API_Member from "@/api/train/member";
import { message } from "ant-design-vue";
import InfoAdmin from "../components/InfoAdmin.vue";
import InfoCoach from "../components/InfoCoach.vue";
import InfoAthletes from "../components/InfoAthletes.vue";
import SelectGroup from "../components/SelectGroup.vue";
import DateManage from "@/views/schedule/date.vue";
import Content from "@/views/schedule/content.vue";

export default {
  components: {
    InfoCoach,
    InfoAdmin,
    InfoAthletes,
    SelectGroup,
    DateManage,
    Content
  },
  data() {
    return {
      id: null, // 用户id
      type: 2, // 2 - 运动员 3-教练员 1,4-管理人员/队医
      time: new Date(),
      tabName: 'info',
      info: {},
      operatingList: [],
      // userTypeObj: this.$store.state.app.userTypeObj, // 用户角色
      userTypeObj: {
        1: "管理员",
        2: "运动员",
        3: "教练",
        4: "队医",
        5: "队伍管理者",
      },
      // 显示修改组别弹框
      showChangeGroup: false,
      setGroupData: {
        name: "",
        userInfo: {},
        tId: null,
        gId: null,
      },
      // 显示修改状态弹框
      showChangeStatus: false,
      setStatusData: {
        status: 1, // 状态
        statusRemark: null, // 备注
      },
      citys: [],
      statusOptions: [
        { label: "正常", value: 1 },
        { label: "停用", value: -1 },
      ],
    };
  },
  provide() {
    return {
      getId: () => this.id,
      getInfo: () => this.info,
      getOperatingList: () => this.operatingList,
      passTime: () => this.time,
      callBack: this.callBack,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
  },
  mounted() {
    this.getCitys();
  },
  methods: {
    callBack(e) {
      this.time = e;
    },
    tabClick(tab, event) {
      console.log(tab, event);
    },
    getCitys() {
      let url = `administrativeArea.json`;
      axios.get(url, {}, false, true).then((res) => {
        console.log(res);
        this.citys = res.data || [];
        this.getInfo();
        this.getOperatingRecord();
      });
    },
    getInfo() {
      API_Member.memberInfo(this.id).then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          res.data.educations
            ? res.data.educations.forEach((item, index) => {
              item.educationTime = item.educationTime.split("-");
              item.startTime = +item.educationTime[0];
              item.endTime = +item.educationTime[1];
            })
            : [];
          res.data.teaches
            ? res.data.teaches.forEach((item, index) => {
              item.teachingTime = item.teachingTime.split("-");
              item.startTime = +item.teachingTime[0];
              item.endTime = +item.teachingTime[1];
            })
            : [];
          this.info = res.data;
          this.setGroupData.gId = this.info.groupId;
          this.setGroupData.tId = this.info.teamId;
          this.info.nativePlace_name = this.getCityById(this.info.nativePlace);
          this.info.birthday = res.data.birthday
            ? moment(this.info.birthday).format("YYYY-MM-DD")
            : "";
          this.info.workingTime = res.data.workingTime
            ? moment(this.info.workingTime).format("YYYY-MM-DD")
            : "";
        }
      });
    },
    getCityById(code, arr = this.citys) {
      if (!code) {
        return "";
      }
      const findItem = arr.find((item) =>
        JSON.stringify(item).includes(`"code":"${code}"`)
      );
      if (!findItem) return "";
      else if (findItem.code == code) {
        return findItem.name;
      } else {
        return this.getCityById(code, findItem.areaList);
      }
    },
    // 修改组别弹框
    changeGroup(type = 0, item) {
      if (type == 0) {
        this.showChangeGroup = false;
      }
      if (type == 1) {
        // 修改单个用户
        this.setGroupData.type = 1;
        this.setGroupData.userInfo = this.info;
        this.setGroupData.name = this.info.name;
        this.showChangeGroup = true;
      }
    },
    // 设置状态弹框
    changeStatus(type = 0) {
      if (type == 0) {
        this.showChangeStatus = false;
      } else {
        this.showChangeStatus = true;
        this.setStatusData = {
          status: this.info.status, // 状态
          statusRemark: this.info.statusRemark, // 备注
        };
      }
    },
    // 修改用户组别
    setGroupChange(res) {
      console.log(res);
      this.setGroupData.tId = res.tId;
      this.setGroupData.gId = res.gId;
    },
    // 确定修改组别
    doChangeGroup() {
      if (!this.setGroupData.gId) {
        message.error("请选择运动组");
        return
      }
      this.changeGroup(0);
      let params = {
        teamId: this.setGroupData.tId,
        groupId: this.setGroupData.gId,
        id: this.id,
      };

      API_Member.setGroup(params).then((res) => {
        if (res.code == 200) {
          message.success("修改组别成功！");
          this.getInfo();
          this.getOperatingRecord();
        }
      });
    },
    // 确定修改状态
    doChangeStatus() {
      this.changeStatus(0);
      let params = {
        statusRemark: this.setStatusData.statusRemark,
        status: this.setStatusData.status,
        ids: [this.id],
      };
      API_Member.setStatus(params).then((res) => {
        if (res.code == 200) {
          message.success("修改状态成功！");
          this.getInfo();
          this.getOperatingRecord();
        }
      });
    },
    // 获取用户操作记录
    getOperatingRecord() {
      API_Member.operateRecord({ bizId: this.id, type: 1 }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            item.dayTxt = moment(item.createTime).format("YYYY-MM-DD");
            item.timeTxt = moment(item.createTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
          this.operatingList = res.data;
          console.log(this.operatingList, "operatingList");
        }
      });
    },
    linkMemberAnalyse() {
      this.$router.push({
        path: "/sportCenter/member/analyse",
        query: {
          id: this.info.id,
        },
      });
    },
    linkMemberRecord() {
      console.log('this.info')
      console.log(this.info)
      this.$router.push({
        path: "/sportCenter/member/record",
        query: {
          id: this.info.id,
          name: this.info.name,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;

  .name {
    font-size: 1.2em;
    font-weight: bold;
    color: #fff;
  }

  .typeTag {
    display: inline-flex;
    align-items: center;
    height: 32px;
    padding: 0 32px;
    border-radius: 20px;
    color: #fff;
    background-color: #fda827;
  }
}
</style>
